import React, { useEffect, useState } from 'react';
import HeadlessModal from '../shared/HeadlessModal';
import { useTranslations } from 'next-intl';
import { RestaurantTag } from '@/lib/types/customer/RestaurantTags';
import { STOREFRONT } from '@/lib/utils/translation';
interface ViewAllTagsModalProps {
  showViewAllTag: boolean;
  setShowViewAllTag: (show: boolean) => void;
  tagsData?: RestaurantTag[];
  parentTagInSearchParams?: RestaurantTag | null;
  childTagInSearchParams?: RestaurantTag | null;
  updateSearchParams: (value?: string, idx?: number) => void;
  updateSlides: (slide: RestaurantTag) => void;
}

function ViewAllTagsModal({
  showViewAllTag,
  setShowViewAllTag,
  tagsData,
  parentTagInSearchParams,
  childTagInSearchParams,
  updateSearchParams,
  updateSlides,
}: Readonly<ViewAllTagsModalProps>) {
  const t = useTranslations('');
  const [query, setQuery] = useState('');
  const [filteredTags, setFilteredTags] = useState<RestaurantTag[]>([]);
  const [sortedTags, setSortedTags] = useState<RestaurantTag[]>([]);

  useEffect(() => {
    if (tagsData && tagsData?.length > 0) {
      const copiedTagsArr = [...tagsData];
      const sortedTagsArray = copiedTagsArr?.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        // Check if the name starts with a special character or a number
        const isSpecialA = /^[^a-zA-Z]/.test(nameA);
        const isSpecialB = /^[^a-zA-Z]/.test(nameB);
        // Prioritize special character or number names
        if (isSpecialA && !isSpecialB) return -1;
        if (!isSpecialA && isSpecialB) return 1;
        // Sort alphabetically within the categories
        return nameA.localeCompare(nameB);
      });
      setSortedTags(sortedTagsArray || []);
      setFilteredTags(sortedTagsArray || []);
    }
  }, [tagsData]);

  const handleTagInputSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchedText = event.target.value;
    if (searchedText?.length > 0) {
      setQuery(searchedText);
      const desiredTags = tagsData?.filter((tag) =>
        tag.name?.toLowerCase()?.includes(searchedText?.toLowerCase())
      );
      if (desiredTags) {
        setFilteredTags(desiredTags);
      }
    } else {
      setQuery('');
      setFilteredTags(sortedTags);
    }
  };

  return (
    <HeadlessModal
      isOpen={showViewAllTag}
      closeModal={() => {
        setShowViewAllTag(false);
      }}
      title={t(`${STOREFRONT.SEARCH}.all_categories`)}
      dialogPanelClassName="md:w-[70%] lg:w-[50%]"
    >
      <div className="mt-5">
        <div className="">
          <input
            type="search"
            placeholder={t(`${STOREFRONT.SEARCH}.search_category`)}
            className="searchPageSearch mb-[48px] mr-0 h-[48px] w-full rounded-xl border border-gray-100 bg-white px-7 py-[21px] shadow-sm outline-0 focus:border-gray-200 focus:ring-0 md:mb-0 md:mr-5"
            onChange={handleTagInputSearch}
          />
        </div>
        <div className="max-h-[70vh] overflow-y-auto">
          <div
            // className="mt-5 flex max-h-[470px] flex-wrap items-center gap-4 overflow-y-auto"
            className="mt-5 columns-1 gap-4 space-y-4 overflow-y-auto sm:columns-2 xl:columns-3"
          >
            {query.length <= 0 && (
              <span
                role="button"
                onClick={() => {
                  if (
                    childTagInSearchParams?.parent_id &&
                    !parentTagInSearchParams?.id
                  ) {
                    updateSearchParams(
                      childTagInSearchParams.parent_id.toString()
                    );
                  }
                  setShowViewAllTag(false);
                }}
                className={`block w-full rounded border border-gray-50 px-6 py-2 ${
                  parentTagInSearchParams?.id && !childTagInSearchParams
                    ? 'text-primary'
                    : 'text-paragraph'
                } shadow-sm`}
              >
                {t(`${STOREFRONT.SEARCH}.all`)}
              </span>
            )}
            {filteredTags?.map((tag: RestaurantTag, idx: number) => {
              return (
                <span
                  key={`vat-${tag.id}-${idx}`}
                  role="button"
                  onClick={() => {
                    updateSlides(tag);
                  }}
                  className={`block w-full rounded border border-gray-50 px-6 py-2 ${
                    parentTagInSearchParams?.id === tag.id ||
                    childTagInSearchParams?.id === tag.id ||
                    childTagInSearchParams?.parent_id === tag.id
                      ? 'text-primary'
                      : 'text-paragraph'
                  } shadow-sm`}
                >
                  {tag.name}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </HeadlessModal>
  );
}

export default ViewAllTagsModal;
